import {
  DevToolItem,
  TableItem,
} from "@components/dev-features-dialog/features";

interface DevFeaturesButtonProps {
  /** Whether the current environment is production */
  isProduction: boolean;

  /** Whether the current user is an internal user */
  isInternalUser: boolean;

  /** Whether the dev mode is enabled */
  isDevModeEnabled: boolean;

  /** Whether the alpha testing mode is enabled */
  isAlphaTestingEnabled: boolean;

  /** Whether the beta testing mode is enabled */
  isBetaTestingEnabled: boolean;
}

/**
 * Checks if the dev features button should be shown depending on the environment and flags.
 * For non-prod environments, it is always shown.
 * For prod environment, it is only shown for internal users if at least one of the dev, alpha or beta modes are enabled.
 * @returns true if the button should be shown
 */
export function shouldShowDevFeaturesButton({
  isProduction,
  isInternalUser,
  isDevModeEnabled,
  isAlphaTestingEnabled,
  isBetaTestingEnabled,
}: DevFeaturesButtonProps): boolean {
  // Always show in any non-prod environments
  if (!isProduction) {
    return true;
  }

  // For prod environment, only show for internal users
  if (!isInternalUser) {
    return false;
  }

  // Do not show if at least one of dev, alpha or beta modes are not enabled for prod internal users
  if (!(isDevModeEnabled || isAlphaTestingEnabled || isBetaTestingEnabled)) {
    return false;
  }
  return true;
}

/** Type guard function for tool toggle items */
export function isToolToggleItem(item: TableItem): item is DevToolItem {
  return "controlType" in item && item.controlType === "toggle";
}

/** Type guard function for tool button items */
export function isToolButtonItem(item: TableItem): item is DevToolItem {
  return "controlType" in item && item.controlType === "button";
}
